import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const MachineryDetailReport = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/standardreport");
  };

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [plotData, setPlotData] = useState([]);

  const [plotId, setPlotId] = useState();

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const FillReport = (employeeId, plotId) => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);
    setCurrentPage(1);
    //console.log("d", d);

    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (plotId > 0) {
      urlfilter = urlfilter + `&plotId=${plotId}`;
    }

    var url = `/api/machineryReportMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getplotDetails } = useHttp();

  const plotDetail = (empId) => {
    var urlfilter = "";

    if (empId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${empId}`;
    }

    getplotDetails(
      {
        url: `/api/plotDetails/?orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
      },
      (data) => {
        var plotlist = data;

        setPlotData(plotlist);
      }
    );
  };

  useEffect(() => {
    plotDetail(0);
  }, [getplotDetails]);

  const fieldsToExport = [
    "startDate",
    "FieldActivityNo",
    "farmManager",
    "plotName",
    "plotArea",
    "plotAreaUnit",
    "cropName",
    "varietyName",
    "areaCovered",
    "areaCoveredUnit",
    "fieldActivityName",
    "machineType",
    "machinCategory",
    "machineCode",
    "ownershipType",
    "workHr",
    "cost",
  ];

  const customHeaders = [
    "Date",
    "FieldActivityNo",
    "Farm Manager",
    "Plot Name",
    "Plot Area",
    "Unit",
    "Crop Name",
    "Variety Name",
    "Area Covered",
    "Area Covered Unit",
    "Activity Name",
    "Machine Type",
    "Machine Classification",
    "Model Name",
    "Ownership Type",
    "Duration(Hrs)",
    "Cost",
  ];

  const handleExportExcel = () => {
    const filename = "MachineDetails.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Machinery Detail Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <hr />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{"Procurement Officer"}</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                      plotDetail(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Plot</label>
                  <select
                    id="plotId"
                    className="form-control"
                    value={plotId}
                    onChange={(e) => {
                      setPlotId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {plotData &&
                      plotData.map((x) => (
                        <option key={x.plotId} value={x.plotId}>
                          {x.plotName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, plotId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>

              <div className="col-md-3"></div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Date </th>
                          <th> FieldActivityNo </th>
                          <th>Farm Manager</th>

                          <th>Plot Name </th>
                          <th> Plot Area </th>
                          <th> Unit </th>
                          <th> Crop Name </th>
                          <th>Variety Name </th>
                          <th> Area Covered </th>
                          <th> Unit</th>
                          <th> Activity Name </th>

                          <th> Machine Type </th>
                          <th> Machine Classification </th>
                          <th> Model Name </th>
                          <th> Ownership Type </th>
                          <th> Duration(Hrs) </th>
                          <th>Cost</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.startDate}</td>
                                <td>{itm.FieldActivityNo}</td>

                                <td>{itm.farmManager}</td>

                                <td>{itm.plotName}</td>

                                <td> {itm.plotArea} </td>
                                <td> {itm.plotAreaUnit} </td>
                                <td> {itm.cropName} </td>
                                <td> {itm.varietyName} </td>

                                <td> {itm.areaCovered} </td>
                                <td> {itm.areaCoveredUnit} </td>
                                <td> {itm.fieldActivityName} </td>
                                <td> {itm.machineType} </td>

                                <td> {itm.machinCategory} </td>
                                <td> {itm.machineCode} </td>
                                <td> {itm.ownershipType} </td>
                                <td> {itm.workHr} </td>

                                <td> {itm.cost} </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MachineryDetailReport;
